import type { TypedMyHotelFeature } from './-MyHotelFeature';
import RawMyHotelFeature from './MyHotelFeature.vue';
export * from './-MyHotelFeature';
export const MyHotelFeature = RawMyHotelFeature as typeof TypedMyHotelFeature;
